import React from 'react';
import './Products.css'

const Products = (props) => {
    const {name , img , price, seller , ratings} = props.product; 
    ///let product = props.product;
    return(
        <div className='all-product'>
            <img src={img} alt="Product Not found" srcset="" />
            <div className="all-product-info">
                <h3>{name}</h3>
                <h4>Price :$ {price}</h4>
                <h5>Manufacturer : {seller}</h5>
                <p>Rating : {ratings} Stars</p>
                <button onClick={()=>props.btnClick(props.product)}>Add To Cart <i class="fa-solid fa-cart-plus"></i></button>
            </div>
        
        </div>
    )
};    

export default Products;